/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MyDbProductDetails
 */
export interface MyDbProductDetails {
    /**
     * 
     * @type {string}
     * @memberof MyDbProductDetails
     */
    tenant: string;
    /**
     * 
     * @type {number}
     * @memberof MyDbProductDetails
     */
    numDatabases?: number;
    /**
     * 
     * @type {number}
     * @memberof MyDbProductDetails
     */
    storageCapacityInGb?: number;
    /**
     * Maximale Anzahl Datensätze pro Datenbank (null/0 = unbegrenzt)
     * @type {number}
     * @memberof MyDbProductDetails
     */
    maxEntriesPerDatabase?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof MyDbProductDetails
     */
    templateCanonicalIds?: Array<string>;
}

/**
 * Check if a given object implements the MyDbProductDetails interface.
 */
export function instanceOfMyDbProductDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "tenant" in value;

    return isInstance;
}

export function MyDbProductDetailsFromJSON(json: any): MyDbProductDetails {
    return MyDbProductDetailsFromJSONTyped(json, false);
}

export function MyDbProductDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyDbProductDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tenant': json['tenant'],
        'numDatabases': !exists(json, 'numDatabases') ? undefined : json['numDatabases'],
        'storageCapacityInGb': !exists(json, 'storageCapacityInGb') ? undefined : json['storageCapacityInGb'],
        'maxEntriesPerDatabase': !exists(json, 'maxEntriesPerDatabase') ? undefined : json['maxEntriesPerDatabase'],
        'templateCanonicalIds': !exists(json, 'templateCanonicalIds') ? undefined : json['templateCanonicalIds'],
    };
}

export function MyDbProductDetailsToJSON(value?: MyDbProductDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tenant': value.tenant,
        'numDatabases': value.numDatabases,
        'storageCapacityInGb': value.storageCapacityInGb,
        'maxEntriesPerDatabase': value.maxEntriesPerDatabase,
        'templateCanonicalIds': value.templateCanonicalIds,
    };
}

